































































import { Component, Prop, Vue } from 'vue-property-decorator';
import CartePeriode from '@/components/MainSection/CartePeriode.vue';
import CarteObjet from '@/components/MainSection/CarteObjet.vue';
import CarteSiteCollection from '@/components/MainSection/CarteSiteCollection.vue';

@Component({
	components: {
		CartePeriode,
		CarteObjet,
		CarteSiteCollection
	}
})
export default class Periode extends Vue {
	@Prop({ required: true })
	periode!: any;
}
